<template>
  <div class="Fuell-Table--row clickable" @click="showMerchantDetailsModal">
    <div class="Fuell-Table--item">
      <div class="flex dark">
        <user-name-badge :userName="merchantName" :userAvatarId="merchantLogo" :backgroundClass="merchantClass"></user-name-badge>
      <span class="ellipsis">
      {{merchantName}}
      </span>
      </div>
    </div>
    <div class="Fuell-Table--item">
      {{merchantMatchers}}
    </div>
    <div class="Fuell-Table--item">{{merchantBusinessName}}</div>
    <div class="Fuell-Table--item">{{merchantCif}}</div>
    <div class="Fuell-Table--item">{{merchantIdentifiers}}</div>
  </div>
</template>

<script>
import UserNameBadge from '@/components/Commons/UserNameBadge'
import _merchantsMixin from '@/modules/merchants/_mixins/_merchantsMixin'
export default {
  name: 'MerchantsTableRow',
  props: {
    merchant: {
      type: Object,
      required: true
    }
  },
  mixins: [
    _merchantsMixin
  ],
  components: {
    UserNameBadge
  },
  computed: {
    merchantName () {
      return this.merchant.name ? this.merchant.name : ''
    },
    merchantBusinessName () {
      return this.merchant.businessName ? this.merchant.businessName : ''
    },
    merchantMatchers () {
      return this.merchant.matchers ? this.getMatchersAsCommaSeparatedList(this.merchant.matchers) : ''
    },
    merchantCif () {
      return this.merchant.registrationNumber ? this.merchant.registrationNumber : ''
    },
    merchantIdentifiers () {
      return this.merchant.merchantIdentifiers.length > 0 ? this.merchant.merchantIdentifiers.join(',') : ''
    },
    merchantLogo () {
      return this.merchant.logo && this.merchant.logo.id ? this.merchant.logo.id : null
    },
    merchantClass () {
      return this.merchant.logo && this.merchant.logo.id ? 'badge-border bg-white' : 'badge-border bg-secondary'
    }
  },

  methods: {
    showMerchantDetailsModal () {
      this.$emit('showMerchantDetailModal', this.merchant.id)
    }
  }

}
</script>
